import React from 'react';

export function Info() {
  return (
      <>
        <div
            className="bg-remark p-4 rounded border border-label overflow-hidden">
          <h4 className="lg:text-lg font-bold mb-4">【產品詳情】</h4>
          <ol className="list-decimal list-inside mb-8">
            <li className="mb-4">三層掛耳式外科口罩 (50片) - 每盒$119</li>
            <li className="mb-4">同舟安心丹 (六個月口罩保障計劃)<br/>
              <p className="mt-4">以下價格未包含運費：</p>
              <ol className="mt-4 ml-8 list-disc list-inside mb-4">
                <li className="mb-4">每月1盒計劃 $714 (共6個月)</li>
                <li className="mb-4">每月2盒計劃 $1,428 (共6個月)</li>
                <li className="mb-4">每月4盒計劃 $2,856 (共6個月)</li>
                <li className="mb-4">每月8盒計劃 $5,712 (共6個月)</li>
              </ol>
              <p className="mb-4">*六個月一次性總付款額</p>
              以下價格已包含運費 (每月$30，6個月共$180)：
              <ol className="mt-4 ml-8 list-disc list-inside mb-4">
                <li className="mb-4">每月1盒計劃 $894 (共6個月)</li>
                <li className="mb-4">每月2盒計劃 $1,608 (共6個月)</li>
                <li className="mb-4">每月4盒計劃 $3,036 (共6個月)</li>
                <li className="mb-4">每月8盒計劃 $5,892 (共6個月)</li>
              </ol>
              <p>*六個月一次性總付款額</p>
            </li>
          </ol>

          <h4 className="lg:text-lg font-bold mb-4">【口罩規格】</h4>
          <ol className="list-decimal list-inside mb-8">
            <li className="mb-4">同舟三層掛耳式外科口罩</li>
            <li className="mb-4">香港製造</li>
            <li className="mb-4">成人口罩 17.5cm x 9.5cm</li>
            <li className="mb-4">每盒50個</li>
            <li className="mb-4">BFE, PFE &gt; 99%</li>
            <li className="mb-4">SGS認證 ASTM Level 2</li>
            <li className="mb-4">香港ISO-14644 Class 8無塵間口罩工廠內生產</li>
            <li className="mb-4">固定優質原材料供應商</li>
          </ol>

          <h4 className="lg:text-lg font-bold mb-4">【運送方式】</h4>
          <ol className="list-decimal list-inside mb-8">
            <li className="mb-4">
              順豐速運
              <ol className="mt-4 ml-8 list-disc list-inside mb-8">
                <li className="mb-4">需另付每月$30運費，六個月共$180</li>
                <li>每月由順豐速運配送你所預訂的口罩數量</li>
              </ol>
            </li>
            <li className="mb-4">
              門市自取
              <ol className="mt-4 ml-8 list-disc list-inside mb-8">
                <li className="mb-4">觀塘成業街16號怡生工業中心地下F鋪<br/>
                  營業時間 :<br/>
                  星期一至日 : 上午9時至下午8時30分
                </li>
                <li>火炭坳背灣街57號利達工業中心地下7A<br/>
                  營業時間 :<br/>
                  星期一至五 : 上午9時至下午5時30分<br/>
                  星期六 : 上午9時至下午12時30分<br/>
                  星期日及公眾假期 休息<br/>
                </li>
              </ol>
            </li>
          </ol>

          <h5 className="font-bold mb-4">自取詳情：</h5>
          <p className="mb-4">當貨品到達您選擇的門市時，我們每個月會於指定時間發送訂單資料到你所登記的電郵地址。你可於分店的營業時間內到提貨通知書上列明的分店提貨。提貨時，請向店員提供提貨通知書上的銷售單編號和您送貨資料內的聯絡電話，以便店員核對訂單資料，確認資料無誤後，即可提取貨品。</p>

          <h5 className="font-bold mb-4">提貨時間：</h5>
          <ol className="list-decimal list-inside mb-8">
            <li className="mb-4">您須於提貨通知書上列明的提貨限期內前往門市提取貨品，門市只會在貨品到店後保留5天。如貨品於提貨限期後仍未被提取，將視作放棄提貨權，該訂單將會被自動取消。</li>
            <li className="mb-4">門市僅提供提貨服務，若顧客對收到的貨品有任何疑問，門市職員恕未能為您解答貨品問題及辦理退貨，故請直接聯絡我們。</li>
            <li className="mb-4">若因顧客所登記的電話或電郵填寫錯誤導致無法聯繫，一切後果須由顧客自行負責。</li>
            <li className="mb-4">門市職員僅核對銷售單編號及聯絡電話，若顧客委託他人代為提貨，本司恕不就所涉及的風險或損失負責。</li>
            <li className="mb-4">如有任何爭議，同舟 Unite Mask將保留最終決定權。</li>
          </ol>

          <h4 className="lg:text-xl font-bold mb-4">【條款及細則】</h4>
          <ol className="list-decimal list-inside mb-8">
            <li className="mb-4">一經付款，我們將無法為閣下修改或取消訂單。</li>
            <li className="mb-4">首月的交貨期將於2020年6月內送到指定地址或門市自取，其後月份則根據付款之先後次序配送，貨品會於該月份後起計最遲14天前送到，即7月起的貨品，最遲會於8月中前送到，如似類推。</li>
            <li className="mb-4">如本公司未能於指定時間內配送貨品到指定地址，將會安排把當月已收取之費用退款；</li>
            <li className="mb-4">如有品質問題要求退款可退款，除品質問題外，其他原因一概不獲受理；</li>
            <li className="mb-4">買方需要自行安排所有退貨之運送，本公司恕不予安排回收；</li>
            <li className="mb-4">閣下所提供的資料只會用作購買相關商品之用，不會做任何其他用途，亦不會把資料傳送給主辦單位或服務供應商外的任何第三方，資料亦會在商品派送完畢後三個月内銷毀；</li>
            <li className="mb-4">如有任何爭議，同舟 Unite Mask 將保留最終決定權；</li>
            <li className="mb-4">如有任何貨品查詢，歡迎電郵至我們的客戶服務{' '}
              <a className="hover:underline"
                 href="mailto:info@unitemaskhk.com">
                info@unitemaskhk.com
              </a>
              。
            </li>
          </ol>

          <h4 className="lg:text-lg font-bold mb-4">About us:</h4>
          <p className="mb-4">同舟UniteMask 由7哥及 7嫂老闆娘
            於2020年3月份創立，用「同舟」作口罩品牌之名字，以同舟共濟 寄寓香港人團結互助，同心協力，定能走出困局，實踐港人自救！</p>

          <p className="mb-8">同舟共濟
            出自《孫子·九地》，典故為春秋時代，吳人與越人交惡，但當其同舟而濟，遇風有難，其相救也，如左右手。比喻雙方在危難中同心協力，不分你我，共渡難關。香港由一個小漁村經過多年努力成為了國際大都會，全有賴同熱愛這遍土地的每一位香港人，縱然香港正面對重重困難，凝聚就是我們最大的力量。同舟UniteMask
            的Logo以中式帆船作基調，意旨向帶領香港由漁村走到國際大都會的每一位致敬，同時希望延續這份香港精神！</p>

          <h4 className="lg:text-lg font-bold mb-4">【你問我答】</h4>
          <ol className="list-decimal list-inside">
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">同舟 Unite Mask
                的創辦人是誰？</p>
              <p>由東方文具公司老闆羅先生及小魔怪創辦人蘇小姐於2020年3月份創立，用「同舟」作口罩品牌之名字，以同舟共濟寄寓香港人團結互助，同心協力，定能走出困局！</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">什麼是同舟安心丹 - 6個月保障計劃？</p>
              <p>同舟希望香港人不用每個月四出搜羅口罩，所以推出一個為期6個月的保障計劃，由同舟每個月配送已預訂的口罩數量到指定地點，希望香港人足不出戶就得到同舟的保障。</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">口罩廠房在哪裡生產？</p>
              <p>所有的口罩都是在香港生產的！</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">口罩有認證嗎？</p>
              <p>口罩已獲得SGS的ASTM Level 2 認證。</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">口罩原材料的產地？</p>
              <p>原材料由於內地設廠的港商提供，所有原材料都有BFE, PFE &gt; 99%的效能。</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">無塵間的衛生標準是什麼？</p>
              <p>同舟生產口罩的無塵間已經得到ISO的官方認證，達到標準ISO-14644 Class
                8的要求，無塵間每立方米內的微粒不超過10萬粒及每小時換氣達22次，無塵間還符合ISO-13485的醫療器材品質管理系統標準。</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">口罩第一次出貨日期？</p>
              <p>預計於6月內。</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">可否自取？</p>
              <p>可以，可選擇於東方文具及小魔怪的火炭及觀塘門市自取。</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">為什麼要一次收取半年的費用？</p>
              <p>第一，我們希望有穩定的原材料去生產口罩，所以我們計劃與原材料工廠簽定一份長期合約，並且全額支付原材料費用，以確保我們所有口罩都是使用同一種優質原材料去生產。第二，我們希望有足夠的資金投入口罩工廠發展第二期，致力生產小童及幼童口罩。</p>
            </li>
            <li className="mb-4">
              <p className="font-bold mb-2 inline-block">使用優質原材料去生產口罩的重要性？</p>
              <p>如果生產口罩時轉換了原材料，便需要重新檢驗再領取認證，每次檢驗費用不菲，而若原材料供應來自來歷不明的廠家，就會有機會影響口罩的保護功效，所以，如果生產使用的原材料並非來自一個穩定的供應商，一張口罩證書並不代表該口罩的永久品質。</p>
            </li>
          </ol>

        </div>
      </>
  );
}
